import styled, { css, keyframes } from 'styled-components';
export const ButtonStyle = styled.button `
  box-sizing: border-box;
  width: ${(props) => (props.isBlock ? '100%' : 'fit-content')};
  color: ${(props) => (props.isFull ? 'white' : props.theme.colors.mainColor)};
  border-radius: ${props => props.theme.borders.buttonBorderRadius};
  box-shadow: ${props => props.theme.boxes.boxShadow};
  border: ${(props) => props.noBorder ? 'none' : props.theme.utils.borderColor(props.theme.utils.getColor('main'))};
  font-size: ${props => props.theme.fonts.buttonTextSize};
  font-family: ${props => props.theme.fonts.fontFamily};
  cursor: pointer;
  user-select: none;
  padding: ${props => props.theme.paddingsMargins.themeMenuPadding};
  padding-left: ${props => props.theme.paddingsMargins.themePaddingSingle};
  padding-right: ${props => props.theme.paddingsMargins.themePaddingSingle};
  margin: ${props => props.theme.paddingsMargins.themeMenuMargin};
  background-color: ${(props) => (props.isFull ? props.theme.colors.mainColor : 'white')};
  transition: all 200ms ease-in-out;
  transform: translateY(0);
  ${props => props.mediaQuery};
    ${(props) => props.secondary &&
    css `
      border: ${(props) => props.noBorder ? 'none' : props.theme.utils.borderColor(props.theme.utils.getColor('secondary'))};
      background-color: ${(props) => props.isFull ? props.theme.colors.secondaryColor : 'white'} !important;
    `};
  ${(props) => props.noMargin &&
    css `
      margin: 1px 1px 1px 1px;
    `};
  ${(props) => props.noBorder &&
    css `
      background-color: transparent;
      border: none !important;
      border-radius: none !important;
      box-shadow: none;
      transition: none;
    `};
    ${(props) => props.color && !props.secondary &&
    css `
      border: ${(props) => props.noBorder ? 'none' : props.theme.utils.customBorders(props.color)} !important;
      background-color: ${(props) => props.isFull ? props.theme.utils.getColor(props.color) : 'white'} !important;
    `};
    ${(props) => props.isDisabled &&
    css `
        cursor: not-allowed;
        background-color: ${props.theme.colors.greyColor} !important;
        border: none !important;
        transition: none !important;
        box-shadow: none !important;
      `};

  &:hover {
    box-shadow: ${props => props.theme.boxes.boxShadowTransition};
    transform: translateY(-2px);
    ${(props) => props.noMargin &&
    css `
        box-shadow: none !important;
        transform: translateY(0px);
      `}
      ${(props) => props.noBorder &&
    css `
          box-shadow: none !important;
          transform: translateY(0px);
        `}
        ${(props) => props.isDisabled &&
    css `
            transform: none;
            &:hover {
              box-shadow: none;
            }
          `};
  }

  &:active {
    box-shadow: none;
    transform: translateY(0);
  }
`;
export const actionText = keyframes `
 0% {
    opacity: 0;
  }
  50%{
    transform: translateY(-0.2rem);
  }
  100% {
    transform: translateY(0rem);
    opacity: 1;
  }
`;
export const ActionResultContainer = styled.div `
    box-sizing: border-box;
    position: relative;
    transform: translateY(2rem);
    opacity: 0;
    border: none;
    cursor: default;
    background-color: transparent;
    display: inline-flex;
    margin: ${props => props.theme.paddingsMargins.themeMenuMargin};
    margin-top: -0.5rem;
    animation: ${actionText} 500ms ease-in forwards;
    & img {
      margin-left: 0.2rem;
      margin-right: 0.5rem;
      height: auto;
      width: 15px;
    }
    ${(props) => props.noMargin &&
    css `
        margin: 1px 1px 1px 1px;
      `}
  `;
